export interface Expert {
  id: string;
  name: string;
  nameEn: string;
  nickname?: string;
  nationality: string;
  birthYear?: string;
  category: 'academic' | 'industry' | 'international';
  subCategory: string;
  title: string;
  titleEn: string;
  affiliation: string;
  affiliationEn: string;
  education: string;
  headline: string;
  headlineEn: string;
  achievements: string[];
  rwaContribution: string;
  story: string;
  historicalParallel: {
    novel: 'sanguo' | 'shuihu';
    novelEn: string;
    character: string;
    characterEn: string;
    intro: string;
    introEn: string;
    detail: string;
    teaser: string;
    teaserEn: string;
  };
  books?: string[];
  projects?: string[];
  color: string;
  icon: string;
}

export const EXPERTS: Expert[] = [
  // ===== 学术奠基人 =====
  {
    id: 'yao-qizhi',
    name: '姚期智',
    nameEn: 'Andrew Chi-Chih Yao',
    nationality: '中国',
    birthYear: '1946',
    category: 'academic',
    subCategory: '学术奠基人与技术先驱',
    title: '图灵奖得主 · 清华大学交叉信息研究院院长',
    titleEn: 'Turing Award Laureate · Dean, IIIS Tsinghua University',
    affiliation: '清华大学',
    affiliationEn: 'Tsinghua University',
    education: '台湾大学物理学士；哈佛大学物理博士；伊利诺伊大学香槟分校计算机博士（双博士）',
    headline: '中国区块链领域"诸葛亮" · 图灵奖唯一华人得主 · 姚班培育RWA精英一代',
    headlineEn: 'The "Zhuge Liang" of Chinese Blockchain · Only Chinese Turing Award Laureate · Yao Class Shaped a Generation of RWA Pioneers',
    achievements: [
      '2000年获图灵奖，是迄今唯一获此殊荣的华裔计算机科学家',
      '2004年全职回国，放弃普林斯顿终身教职，创办"姚班"',
      '2011年创办清华大学交叉信息研究院，担任院长',
      '担任Conflux公链（树图区块链）学术指导委员会主任',
      '牵头国家重点研发计划"面向\'一带一路\'的区块链基础平台"',
      '2024年获得基础科学终身成就奖',
    ],
    rwaContribution: '主导Conflux公链核心技术架构，推动"分布式可信确权"技术，解决实体资产数字化中身份认证、权益拆分、实时追溯等关键问题，为政务资产、绿色能源等RWA的合规落地提供技术保障。通过姚班培养出龙凡、李辰星等RWA领域领军人才。',
    story: '2004年，姚期智放弃普林斯顿大学终身教职，全职回国。彼时区块链尚处萌芽，他已预判这项技术将对数字经济产生革命性影响。他创办"姚班"，如同开设"丞相府学"，手把手培育出一批中国区块链的中流砥柱。',
    historicalParallel: {
      novel: 'sanguo',
      novelEn: 'Romance of the Three Kingdoms',
      character: '诸葛亮',
      characterEn: 'Zhuge Liang',
      intro: '诸葛亮隐居隆中时便洞察天下大势，提出"隆中对"；姚期智2004年回国时，便预判区块链技术将对数字经济产生革命性影响，以一己之力撑起中国区块链的"蜀汉基业"。',
      introEn: 'Just as Zhuge Liang formulated the grand strategy "Longzhong Dui" while still in seclusion, Yao Chi-chih foresaw blockchain\'s revolutionary impact on digital economics upon returning to China in 2004 — single-handedly laying the intellectual foundation for China\'s blockchain era.',
      detail: '姚期智之于中国区块链与RWA领域，恰如诸葛亮之于蜀汉，是运筹帷幄、决胜千里的"智囊核心"，更是桃李满天下、奠定基业的"精神领袖"。诸葛亮不恋权位、一心为国，始终坚守学术初心；姚期智也如此，即便获得图灵奖等至高荣誉，依然深耕一线教学与科研，不涉足商业炒作，专注于技术突破与人才培养。如同诸葛亮用智慧撑起蜀汉，姚期智用学术与坚守，撑起了中国区块链与RWA领域的一片天。',
      teaser: '有人说他是"中国区块链的诸葛亮"——他如何以一人之力，奠定中国整个区块链人才体系？',
      teaserEn: 'They call him "China\'s Zhuge Liang of blockchain" — how did one man single-handedly shape an entire generation of China\'s blockchain talent?',
    },
    books: ['《密码学基础》', '《计算复杂性理论》', '《量子计算导论》'],
    projects: ['清华学堂计算机科学实验班（姚班）', '清华大学交叉信息研究院', 'Conflux公链（学术指导）'],
    color: '#7C3AED',
    icon: 'ri-award-line',
  },
  {
    id: 'long-fan',
    name: '龙凡',
    nameEn: 'Long Fan',
    nationality: '中国',
    category: 'academic',
    subCategory: '学术奠基人与技术先驱',
    title: 'Conflux联合创始人 & CTO · 树图区块链研究院院长',
    titleEn: 'Co-founder & CTO of Conflux · President of TreeGraph Blockchain Institute',
    affiliation: '上海树图区块链研究院',
    affiliationEn: 'Shanghai TreeGraph Blockchain Research Institute',
    education: '清华大学"姚班"本科；MIT计算机科学博士（师从Silvio Micali）',
    headline: '姚期智嫡传弟子 · 打造中国自主可控高性能公链 · TPS突破6500的技术缔造者',
    headlineEn: 'Yao\'s top disciple · Creator of China\'s self-reliant high-performance public chain · TPS breakthrough of 6,500',
    achievements: [
      '2008年入选首批"姚班"，被姚期智亲自选拔的核心弟子',
      '2017年获MIT博士学位，博士论文获MIT优秀博士论文奖',
      '2018年拒绝谷歌、Facebook百万年薪，回国创办树图区块链研究院',
      '研发"树图"共识机制，TPS突破6500，打破国外技术垄断',
      'Conflux成为国内唯一获国家网信办区块链信息服务备案的公链之一',
      '担任国家重点研发计划项目负责人',
    ],
    rwaContribution: '带领团队攻克传统区块链共识机制性能瓶颈，Conflux公链为大规模RWA并发处理提供了中国方案。推动公链与政府、企业合作，落地政务存证、碳资产上链、知识产权确权等多个RWA应用项目。',
    story: '2017年，龙凡还在MIT读博时，就注意到比特币每秒仅能处理7笔交易的致命瓶颈。毕业时，硅谷顶尖科技公司开出百万美元年薪，他一一拒绝。带着论文手稿和研发思路回到中国，与团队挤在上海一间不足100平米的简陋办公室，每天工作超16小时。2019年，Conflux测试网跑出6500 TPS，震惊全球区块链行业。',
    historicalParallel: {
      novel: 'shuihu',
      novelEn: 'Water Margin (Outlaws of the Marsh)',
      character: '卢俊义',
      characterEn: 'Lu Junyi',
      intro: '卢俊义出身大名府富贵之家，自幼习武，枪法天下无双，却甘愿放下"锦衣玉食"投身梁山；龙凡同样放弃了硅谷的高薪与优渥，回到中国创业，成为中国区块链领域的"第二把交椅"。',
      introEn: 'Lu Junyi, born into wealth and gifted with unparalleled martial skills, gave up comfort to join the Liangshan heroes. Similarly, Long Fan abandoned Silicon Valley\'s million-dollar offers to return to China — becoming the No.2 pillar of China\'s blockchain field.',
      detail: '卢俊义武艺天下无双，上梁山后成为核心战力；龙凡密码学与分布式系统天赋异禀，回国后研发Conflux，打破国外技术垄断。卢俊义重情重义、专注实干；龙凡也始终保持低调，即便Conflux取得巨大成功，每天依然泡在实验室调试代码，用实干诠释"英雄本色"。',
      teaser: '他被比作梁山"玉麒麟"卢俊义——MIT博士如何放弃百万年薪，只身回国打造中国自己的高性能公链？',
      teaserEn: 'Compared to Lu Junyi of the Liangshan heroes — how did this MIT Ph.D. turn down million-dollar Silicon Valley offers to build China\'s own world-class blockchain?',
    },
    books: ['《树图区块链共识机制原理与实践》（合著）'],
    projects: ['Conflux公链', '国家重点研发计划"面向\'一带一路\'的区块链基础平台"', '上海树图区块链研究院'],
    color: '#0EA5E9',
    icon: 'ri-git-branch-line',
  },
  {
    id: 'li-chenxing',
    name: '李辰星',
    nameEn: 'Li Chenxing',
    nationality: '中国',
    category: 'academic',
    subCategory: '学术奠基人与技术先驱',
    title: 'Conflux首席科学家 · 树图区块链研究院青年科学家',
    titleEn: 'Chief Scientist, Conflux · Young Scientist, TreeGraph Blockchain Institute',
    affiliation: '上海树图区块链研究院 / MIT',
    affiliationEn: 'Shanghai TreeGraph / MIT',
    education: '清华大学"姚班"本科；MIT计算机科学博士（2022年）；丹麦奥胡斯大学访问学者',
    headline: '大年初二的"一个人的春节" · 发现国际顶级论文致命漏洞 · 树图共识机制共同发明人',
    headlineEn: 'Alone on Chinese New Year eve · Discovered a fatal flaw in a top-tier paper · Co-inventor of the TreeGraph consensus mechanism',
    achievements: [
      '2013年考入"姚班"，为姚期智重点培养的弟子',
      '大年初二独自研读国际论文，发现以色列科学家图式共识协议的致命死锁漏洞',
      '与龙凡共同提出"树图"结构，解决区块链三难困境',
      '2022年获MIT博士学位，成为Conflux首席科学家',
      '主导研发"实体资产上链确权协议"，服务供应链金融RWA落地',
      '当选中国密码学会青年工作委员会委员',
    ],
    rwaContribution: '主导Conflux共识协议的数学证明与工程化实现，研发"实体资产上链确权协议"，解决RWA资产上链过程中的一致性与安全性问题。其提出的VDF（可验证延迟函数）在区块链中的应用方案，进一步提升了公链安全性与效率。',
    story: '2018年大年初二，当所有人都走亲访友时，李辰星一个人窝在清华实验室，反复研读国际顶级会议的图式区块链共识协议论文。他发现了致命的死锁漏洞。经过连续一周的邮件争辩，以色列知名科学家最终承认了设计有误，并邀请他共同完善协议。',
    historicalParallel: {
      novel: 'sanguo',
      novelEn: 'Romance of the Three Kingdoms',
      character: '姜维',
      characterEn: 'Jiang Wei',
      intro: '姜维被诸葛亮慧眼识珠，继承先师遗志，在关键技术领域独当一面；李辰星被姚期智重点培养，继承先师的学术理念，专注区块链核心技术的研发，扛起中国区块链技术创新的大旗。',
      introEn: 'Zhuge Liang personally selected Jiang Wei to carry on his legacy; similarly, Yao Chi-chih singled out Li Chenxing to inherit his academic vision and lead China\'s blockchain technology innovation.',
      detail: '姜维在诸葛亮去世后独撑蜀汉大局，面对质疑始终坚守信念；李辰星面对国际上的技术垄断与质疑，始终坚守信念，用严谨的数学证明与扎实的工程实践，打破了国外的技术壁垒，成为中国区块链领域最具潜力的青年科学家。',
      teaser: '"姜维"接班"诸葛亮"——这位姚班弟子如何在大年初二，独自发现震动国际学界的区块链致命漏洞？',
      teaserEn: 'Like Jiang Wei inheriting Zhuge Liang\'s mission — how did this Yao Class disciple single-handedly uncover a critical blockchain flaw that shook the international academic community on Chinese New Year\'s Day?',
    },
    books: ['《区块链共识协议的数学证明与优化》（合著）', '《树图结构在分布式系统中的应用》'],
    projects: ['Conflux公链共识协议研发', '实体资产上链确权协议', '可验证延迟函数（VDF）在区块链中的应用'],
    color: '#10B981',
    icon: 'ri-microscope-line',
  },
  {
    id: 'cai-weide',
    name: '蔡维德',
    nameEn: 'David Tsai',
    nationality: '中国（台湾）',
    birthYear: '1963',
    category: 'academic',
    subCategory: '学术奠基人与技术先驱',
    title: '北京航空航天大学教授 · "中国RWA合规之父"',
    titleEn: 'Professor, BUAA · "Father of China RWA Compliance"',
    affiliation: '北京航空航天大学区块链实验室',
    affiliationEn: 'Blockchain Lab, Beihang University',
    education: '台湾大学计算机科学学士；南加州大学计算机科学硕士；亚利桑那州立大学计算机科学博士',
    headline: '"RWA不是发币，是给实体资产办数字身份证" · 国内首部区块链合规专著作者 · 三链分立架构提出者',
    headlineEn: '"RWA is not about issuing coins — it\'s giving real assets a digital identity" · Author of China\'s first blockchain compliance book',
    achievements: [
      '1991年获博士学位后，在IBM研究院主导大型金融系统安全合规研发',
      '2010年回国，建立北京航空航天大学区块链实验室',
      '提出"三链分立"（业务链/监管链/存证链）架构，完美适配RWA监管要求',
      '出版《RWA真实世界资产数字化理论与实践》等4部专著',
      '发表50余篇RWA合规、资产代币化核心期刊论文',
      '被业内称为"中国RWA合规之父"',
    ],
    rwaContribution: '主导国内政务资产、绿色能源资产、知识产权上链的合规框架设计。坚决反对无锚定代币，主张RWA必须与法律确权、会计入账、监管可查绑定，引导行业回归实体经济。参与多项国家级区块链标准制定，包括《RWA真实世界资产数字化指南》。',
    story: '在一次部委座谈会上，当时不少人将RWA与"虚拟币炒作"混淆，主张"全面禁止"。蔡维德直言不讳地反驳："RWA不是发币，是给实体资产办数字身份证，是助力实体经济的工具，而非投机炒作的载体。"这句话成为行业金句，改变了不少政策制定者的认知。',
    historicalParallel: {
      novel: 'shuihu',
      novelEn: 'Water Margin (Outlaws of the Marsh)',
      character: '吴用',
      characterEn: 'Wu Yong',
      intro: '吴用号称"智多星"，不靠武力，靠谋略为梁山制定"军规"，引导行业走向规范；蔡维德也不炒币、不搞投机，靠合规框架设计，为中国RWA行业制定规则，引导行业回归实体经济。',
      introEn: 'Wu Yong, known as "The Resourceful Star," guided the Liangshan heroes with strategy rather than force. Similarly, Cai Weide guides China\'s RWA industry through compliance frameworks, not speculation — defining the rules of the game.',
      detail: '吴用最擅长"运筹帷幄"，不亲自冲锋陷阵，却能决胜千里；蔡维德也始终坚守"幕后谋划"的角色，不涉足商业炒作，专注于RWA合规框架的设计与推广，凭借"三链分立"架构，解决了RWA资产上链的合规难题。吴用始终坚守"替天行道"的信念；蔡维德也始终坚守"助力实体经济"的初心，即便面对"币圈"的舆论压力，也始终坚持"无币区块链"方向。',
      teaser: '梁山"智多星"吴用的现代版——他如何在部委座谈会上一句话，改变了整个RWA监管走向？',
      teaserEn: 'The modern Wu Yong of China\'s RWA world — how did one sentence at a ministerial meeting reshape the entire RWA regulatory direction in China?',
    },
    books: ['《区块链监管与合规》(2018)', '《联盟链与资产代币化》(2020)', '《RWA真实世界资产数字化理论与实践》(2022)', '《区块链合规与风险治理》(2024)'],
    projects: ['三链分立架构设计', '北京航空航天大学区块链实验室', '国家级区块链标准制定'],
    color: '#F59E0B',
    icon: 'ri-scales-line',
  },
  {
    id: 'huang-butian',
    name: '黄步添',
    nameEn: 'Huang Butian',
    nationality: '中国',
    birthYear: '1973',
    category: 'academic',
    subCategory: '学术奠基人与技术先驱',
    title: '趣链科技董事长 · 联盟链领域开拓者',
    titleEn: 'Chairman, Qulian Technology · Pioneer of Consortium Blockchain',
    affiliation: '趣链科技',
    affiliationEn: 'Qulian Technology',
    education: '浙江大学计算机科学博士（师从陈纯院士）',
    headline: '抵押房子创业 · 国内联盟链市场占有率第一 · 将知识产权、林权、应收账款等全面RWA化',
    headlineEn: 'Mortgaged his house to start the company · No.1 consortium blockchain in China · Tokenized IP, forest rights, and receivables',
    achievements: [
      '2001-2016年担任浙大计算机科学系教授、博士生导师',
      '2016年辞去高校教职，创办趣链科技，做出国内第一条自主可控联盟链',
      '创业最艰难时抵押自己房子，坚守"无币区块链"方向',
      '趣链科技估值超百亿，服务百余家大型机构',
      '落地上千个区块链应用项目，RWA相关项目占比超60%',
      '担任浙江省区块链标准化技术委员会主任',
    ],
    rwaContribution: '承建大量司法存证、供应链金融、不动产登记链等核心项目，推动知识产权、林权、应收账款等RWA类资产的标准化上链。强调"链上权利≡法律权利"，为RWA的合规落地提供工程化方案。在绿色RWA领域，推动林权、碳资产等绿色资产的上链确权，助力"双碳"目标实现。',
    story: '创业初期，团队面临资金短缺、技术瓶颈、市场质疑。最艰难的时候，黄步添抵押了自己的房子，凑钱给团队发工资，甚至自己带头降薪，坚守初心。如今，趣链科技估值超百亿，但黄步添依然穿着几十元的T恤，泡在公司工位上亲自调试代码。',
    historicalParallel: {
      novel: 'sanguo',
      novelEn: 'Romance of the Three Kingdoms',
      character: '鲁肃',
      characterEn: 'Lu Su',
      intro: '鲁肃踏实稳重、不尚空谈，为人谦和、善于团结各方力量；黄步添也一样，通过"联盟链"这一平台，联合金融机构、政府、企业，共同构建了国内最大的合规区块链生态。',
      introEn: 'Lu Su was steady, humble, and skilled at uniting different forces for a common goal. Huang Butian embodies the same spirit — building China\'s largest compliant blockchain ecosystem by uniting governments, financials, and enterprises.',
      detail: '鲁肃最大的特点是"顾全大局、善于团结"，即便与各方存在分歧，也始终坚守"联蜀抗曹"的初心；黄步添也始终秉持"顾全大局"的理念，不追求个人利益，专注于推动整个区块链行业的健康发展。鲁肃为人谦和、低调务实；黄步添也始终保持低调务实的作风，即便趣链科技成为行业龙头，依然穿着朴素、深耕一线。',
      teaser: '他被比作三国"粘合剂"鲁肃——浙大教授如何抵押房子，建起中国联盟链第一品牌？',
      teaserEn: 'Like Lu Su who united the kingdoms — how did this Zhejiang University professor mortgage his house to build China\'s No.1 consortium blockchain brand?',
    },
    books: ['《联盟链技术与实体资产数字化》(2021)', '《区块链工程实践》(2023)'],
    projects: ['司法存证区块链平台', '供应链金融区块链系统', '不动产登记链', '林权上链项目', '碳资产数字化平台'],
    color: '#059669',
    icon: 'ri-links-line',
  },
  {
    id: 'deng-xiaotie',
    name: '邓小铁',
    nameEn: 'Xiaotie Deng',
    nationality: '中国',
    category: 'academic',
    subCategory: '学术奠基人与技术先驱',
    title: '清华大学教授 · 科技部"十四五"区块链重点专项首席科学家',
    titleEn: 'Professor, Tsinghua University · Chief Scientist, MOST "14th Five-Year" Blockchain Key Program',
    affiliation: '清华大学博弈论与人工智能实验室',
    affiliationEn: 'Game Theory & AI Lab, Tsinghua University',
    education: '北京大学数学学士、计算机硕士；哈佛大学计算机科学博士（师从诺贝尔经济学奖得主Roger Myerson）',
    headline: '用数学证明"无抵押代币终将归零" · 为国家虚拟币禁令提供科学依据 · 区块链博弈论开创者',
    headlineEn: 'Proved mathematically that "unanchored tokens always go to zero" · Provided scientific basis for China\'s crypto ban · Founder of blockchain game theory',
    achievements: [
      '师从诺贝尔经济学奖得主Roger Myerson',
      '用博弈论数学证明无锚定代币必然崩盘，成为境内禁止虚拟币的重要科学依据',
      '创立清华大学博弈论与人工智能实验室',
      '主持科技部"十四五"区块链重点专项',
      '提出"博弈论驱动的RWA定价模型"，解决RWA资产定价难题',
      '兼任上海树图区块链研究院学术顾问',
    ],
    rwaContribution: '提出"博弈论驱动的RWA定价模型"，解决了RWA资产定价难、流动性差的问题。用博弈论证明了"没有实体资产锚定的代币最终都会走向零"，为国家政策制定提供了科学依据，引导行业回归实体经济，推动RWA成为合规发展方向。',
    story: '邓小铁通过博弈论进行大量数学推导，证明无锚定代币本质上是"零和博弈"，最终会崩盘。发表后遭到"币圈"的强烈攻击，有人恶意抹黑他的研究。但他用严谨的数学证明反复论证，最终，他的理论被政策制定者采纳，成为"境内禁止虚拟币"的重要科学依据。',
    historicalParallel: {
      novel: 'shuihu',
      novelEn: 'Water Margin (Outlaws of the Marsh)',
      character: '公孙胜',
      characterEn: 'Gongsun Sheng',
      intro: '公孙胜"法力高强"，不参与寻常打斗，却在关键时刻以"道术"定乾坤；邓小铁也不炒币，却在国家政策制定的关键时刻，以"数学证明"定乾坤，成为中国区块链与RWA领域的"幕后高人"。',
      introEn: 'Gongsun Sheng, the Taoist wizard, rarely fought but resolved crises at critical moments with his powers. Similarly, Deng Xiaotie stayed out of crypto speculation but intervened at the most critical moment — providing mathematical proof that shaped China\'s national blockchain policy.',
      detail: '公孙胜淡泊名利、不恋权位，始终坚守"替天行道"的初心；邓小铁也始终坚守学术初心，不追求名利，不涉足商业炒作，即便遭到攻击与质疑，也始终坚守信念，用科学与严谨，为行业"正名"。公孙胜善于将"道术"与"实战"结合；邓小铁也善于将理论研究与实践应用结合，提出的"RWA定价模型""区块链博弈论"等理论，都能直接应用于RWA落地实践。',
      teaser: '他用数学定理让"币圈"沉默——这位梁山"公孙胜"如何以博弈论，为中国区块链政策奠定科学基础？',
      teaserEn: 'He silenced the crypto world with mathematics — how did this "Gongsun Sheng" of blockchain use game theory to provide the scientific foundation for China\'s blockchain policy?',
    },
    books: ['《区块链博弈论》(2021)', '《分布式系统与区块链理论》(2023)', '《RWA定价模型与风险控制》(2024)'],
    projects: ['科技部"十四五"区块链重点专项', '供应链金融RWA定价系统', '区块链博弈论研究平台'],
    color: '#8B5CF6',
    icon: 'ri-calculator-line',
  },

  // ===== 近十年风云人物 =====
  {
    id: 'xiao-feng',
    name: '肖风',
    nameEn: 'Xiao Feng',
    nationality: '中国',
    birthYear: '1961',
    category: 'industry',
    subCategory: '近十年行业风云人物',
    title: '万向控股副董事长 · 万向区块链实验室创始人',
    titleEn: 'Vice Chairman, Wanxiang Holdings · Founder, Wanxiang Blockchain Labs',
    affiliation: '万向区块链实验室',
    affiliationEn: 'Wanxiang Blockchain Labs',
    education: '南开大学经济学博士',
    headline: '"十年后区块链将像互联网一样无处不在" · 2016年预言成真 · RWA生态最重要的布局者',
    headlineEn: '"In 10 years blockchain will be everywhere like the internet" — said in 2016, came true · Most important RWA ecosystem builder',
    achievements: [
      '博时基金创始人，中国公募基金业开拓者',
      '2015年急流勇退，从公募基金转身区块链领域',
      '创办万向区块链实验室，每年举办"区块链全球峰会"',
      '率先提出"RWA是区块链的终极应用"',
      '投资数十家RWA相关初创企业',
      '2023年推动万向与HashKey合作，打通内地资产赴港RWA发行首个通道',
    ],
    rwaContribution: '率先提出"RWA是区块链的终极应用"，投资数十家RWA相关初创企业，搭建万向区块链生态，推动区块链技术与实体经济融合。2023年打通内地资产赴港RWA发行的首个通道，推动国内RWA领域走向国际化。',
    story: '2016年在闭门会上提出"十年后，区块链会像互联网一样无处不在"，当时台下哄堂大笑。十年后，他的预言成为现实。',
    historicalParallel: {
      novel: 'sanguo',
      novelEn: 'Romance of the Three Kingdoms',
      character: '刘备',
      characterEn: 'Liu Bei',
      intro: '刘备不是顶尖高手，却善于识人用人聚人，以博大胸怀聚拢各路英雄，建立蜀汉；肖风也不是技术研发者，却眼光独到，聚拢全球区块链与RWA领域的技术、产业、学术人才，搭建起最具影响力的区块链生态之一。',
      introEn: 'Liu Bei was not the greatest warrior, but his vision and people skills built the Shu Han kingdom. Xiao Feng mirrors this — not a technologist, but his talent for identifying, attracting, and empowering blockchain talent built one of China\'s most influential blockchain ecosystems.',
      detail: '刘备始终坚守"兴复汉室"的初心，虽屡遭挫折却从未放弃；肖风始终坚守"区块链赋能实体经济"的初心，虽在行业发展初期遭遇质疑和嘲笑，却从未放弃。刘备建立的蜀汉，成为三国鼎立中的重要一极；肖风搭建的万向区块链生态，成为中国区块链与RWA领域的重要阵地。',
      teaser: '"区块链界的刘备"——他如何从公募基金开拓者，转身成为中国RWA生态的最重要布局者？',
      teaserEn: 'The "Liu Bei" of China\'s blockchain world — how did a mutual fund pioneer become the most important architect of China\'s RWA ecosystem?',
    },
    projects: ['万向区块链实验室', '区块链全球峰会', '万向与HashKey内地资产赴港RWA发行通道'],
    color: '#DC2626',
    icon: 'ri-building-line',
  },
  {
    id: 'hu-xiaoming',
    name: '胡晓明',
    nameEn: 'Hu Xiaoming',
    nationality: '中国',
    category: 'industry',
    subCategory: '近十年行业风云人物',
    title: '蚂蚁集团前CEO · 蚂蚁链创始人',
    titleEn: 'Former CEO, Ant Group · Founder, AntChain',
    affiliation: '蚂蚁集团 / 蚂蚁链',
    affiliationEn: 'Ant Group / AntChain',
    education: '中欧国际工商学院EMBA',
    headline: '"区块链不是颠覆银行，是给银行插上翅膀" · 全球最大新能源RWA平台缔造者 · 1400万台新能源设备上链',
    headlineEn: '"Blockchain doesn\'t disrupt banks — it gives banks wings" · Created the world\'s largest clean energy RWA platform · 14 million energy devices on-chain',
    achievements: [
      '曾是银行职员，因对互联网的狂热辞职加入阿里',
      '主导建立蚂蚁链，推动区块链从实验室走向大规模商业应用',
      '2017年聚焦供应链金融、版权保护、公益溯源等RWA场景',
      '2025年蚂蚁链1400万台新能源设备上链，成为全球最大新能源RWA平台',
      '推动蚂蚁链与银行合作，为小微企业提供超3000亿链上融资',
    ],
    rwaContribution: '创办蚂蚁链，推动区块链技术在供应链金融、新能源、版权保护等领域的大规模RWA应用。将1400万台新能源设备上链，成为全球最大新能源RWA平台。为小微企业提供超3000亿的链上融资，解决小微企业融资难问题。',
    story: '提出"区块链不是颠覆银行，而是给银行插上翅膀"，推动蚂蚁链与银行的深度合作。年过五旬依然保持创业激情，被称为"银行出身的区块链追梦人"。',
    historicalParallel: {
      novel: 'shuihu',
      novelEn: 'Water Margin (Outlaws of the Marsh)',
      character: '宋江',
      characterEn: 'Song Jiang',
      intro: '宋江本是体制内小吏，凭借高超的组织能力将108将拧成一股绳；胡晓明本是银行职员，凭借资源整合能力将技术研发者、金融机构、实体企业等生态伙伴团结在一起，打出"区块链解决实际问题"的大旗。',
      introEn: 'Song Jiang, a minor government official, used extraordinary organizational skills to unite 108 heroes into a powerful force. Hu Xiaoming, a former bank clerk, used the same skill to unite technologists, financial institutions, and enterprises under AntChain\'s banner.',
      detail: '宋江的核心能力不在于武功高强，而在于凝聚人心、整合资源；胡晓明的核心能力也不在于技术研发，而在于战略落地、资源整合，让蚂蚁链的技术能力与金融机构、实体企业的实际需求相结合。宋江始终坚守"替天行道"的初心；胡晓明始终坚守"区块链解决实际问题"的初心，为小微企业谋福利，让蚂蚁链成为赋能实体经济的重要工具。',
      teaser: '银行出身的"区块链宋江"——他如何把全球最大的区块链平台，建成全球最大的新能源RWA基础设施？',
      teaserEn: 'The "Song Jiang" of blockchain — how did a former bank clerk build the world\'s largest blockchain platform and the world\'s largest clean energy RWA infrastructure?',
    },
    projects: ['蚂蚁链', '全球最大新能源RWA平台', '蚂蚁链供应链金融平台', '公益溯源区块链项目'],
    color: '#F59E0B',
    icon: 'ri-leaf-line',
  },
  {
    id: 'cao-heng',
    name: '曹恒',
    nameEn: 'Cao Heng',
    nationality: '中国',
    category: 'industry',
    subCategory: '近十年行业风云人物',
    title: '边界智能创始人 · CEO · 跨链技术领军者',
    titleEn: 'Founder & CEO, Bianjie.AI · Leader in Cross-Chain Technology',
    affiliation: '边界智能',
    affiliationEn: 'Bianjie.AI',
    education: '美国弗吉尼亚大学计算机博士',
    headline: '区块链圈罕见女性创业者 · "我回国是因为在美国做的技术很难落地到中国实体经济" · 国内首单林业碳汇RWA融资',
    headlineEn: 'One of blockchain\'s rare female founders · "I returned because my tech couldn\'t reach China\'s real economy from America" · Led China\'s first forestry carbon credit RWA',
    achievements: [
      '曾任IBM Watson研究院科学家，拥有国际顶尖技术研发经验',
      '2016年回国创业，开发IRITA跨链平台',
      '支持异构区块链之间的资产和数据可信流转',
      '2024年为某省林业局搭建"碳汇资产链"，实现国内首单林业碳汇RWA融资',
      '带领30人小团队，做出媲美国际巨头的跨链产品',
    ],
    rwaContribution: '开发IRITA跨链平台，支持异构区块链之间的资产和数据可信流转，为跨境RWA、跨领域RWA提供技术支撑。推动碳汇、林业等绿色资产的RWA落地，实现国内首单林业碳汇RWA融资，助力"双碳"目标实现。',
    story: '圈内少有的女性创业者，曾坦言"我决定回国，是因为在美国做的技术，很难落地到中国的实体经济"。带领30人的小团队，做出媲美国际巨头的跨链产品。',
    historicalParallel: {
      novel: 'shuihu',
      novelEn: 'Water Margin (Outlaws of the Marsh)',
      character: '扈三娘',
      characterEn: 'Hu Sanniang',
      intro: '扈三娘巾帼不让须眉、武艺高强，在一众男性豪杰中独树一帜；曹恒作为区块链圈内为数不多的女性创业者，技术顶尖、眼光独到，凭借跨链技术这一"独门绝技"，成为行业不可或缺的"女将"。',
      introEn: 'Hu Sanniang stood out among male heroes with her exceptional martial skills. Cao Heng similarly stands out in a male-dominated blockchain industry — her cross-chain expertise is the unique weapon that makes her indispensable.',
      detail: '扈三娘本是大小姐，却因家族变故投奔梁山，凭借一身武艺赢得尊重；曹恒本是IBM科学家，却因心系中国实体经济，毅然回国创业，赢得行业的广泛尊重。曹恒的跨链技术，让碳汇、林业、金融等不同领域的RWA资产能实现可信流转，是行业的"独门绝技"。',
      teaser: '梁山"扈三娘"的现代版——这位IBM科学家如何放弃顶尖外企，只身回国，打造中国跨链技术第一人？',
      teaserEn: 'The modern Hu Sanniang of blockchain — how did this IBM scientist leave a top international firm to return to China and become the country\'s leading cross-chain technology expert?',
    },
    projects: ['IRITA跨链平台', '国内首单林业碳汇RWA融资项目', '碳汇资产链', '异构区块链资产流转平台'],
    color: '#10B981',
    icon: 'ri-repeat-2-line',
  },

  // ===== 国际人物 =====
  {
    id: 'satoshi',
    name: '中本聪',
    nameEn: 'Satoshi Nakamoto',
    nationality: '未知（匿名）',
    category: 'international',
    subCategory: '区块链奠基人',
    title: '比特币创始人 · 区块链技术发明者',
    titleEn: 'Creator of Bitcoin · Inventor of Blockchain',
    affiliation: '未知',
    affiliationEn: 'Unknown',
    education: '身份成谜，至今未知',
    headline: '2008年发布比特币白皮书 · 2009年挖出创世区块 · 持有约100万枚从未动用的比特币后神秘消失',
    headlineEn: 'Published Bitcoin whitepaper in 2008 · Mined the genesis block in 2009 · Disappeared with ~1M BTC never touched',
    achievements: [
      '2008年10月31日发表比特币白皮书，首次提出区块链技术概念',
      '2009年1月3日挖出创世区块，正式启动比特币网络',
      '2011年突然消失，留下约100万枚从未动用的比特币',
      '其身份是区块链史上最大谜团，无数人试图找出但均无果',
    ],
    rwaContribution: '区块链技术为RWA提供了去中心化、不可篡改、可信确权的底层账本基础设施，成为RWA发展的核心技术基础。其匿名身份让区块链技术真正实现了去中心化，摆脱了创始人的影响，为后续区块链和RWA的发展树立了去中心化的典范。',
    story: '身份是区块链史上最大的谜团，2011年突然消失，留下约100万枚从未动用的比特币。有人猜测是Hal Finney、Nick Szabo，甚至外星人。其"消失"本身就是最伟大的行为艺术，让去中心化的系统真正摆脱了创始人的影响。',
    historicalParallel: {
      novel: 'sanguo',
      novelEn: 'Romance of the Three Kingdoms',
      character: '左慈',
      characterEn: 'Zuo Ci',
      intro: '左慈是三国时期的道家方士，忽隐忽现、行踪不定，无人知其真面目，却以神奇的道术搅动了各路诸侯；中本聪同样神秘莫测，身份成谜，却以区块链技术搅动了全球金融格局。',
      introEn: 'Zuo Ci was a mysterious Taoist wizard in the Three Kingdoms era — appearing and disappearing at will, identity unknown, yet his magic shook the entire world. Satoshi Nakamoto is identical: anonymous, vanished, yet his blockchain technology shook the global financial order.',
      detail: '左慈的道术不在于炫耀，而在于打破传统的认知，让各路诸侯意识到天外有天；中本聪的区块链技术也不在于单纯创造数字货币，而在于打破传统中心化金融的认知，推动了数字经济的革命。左慈虽行踪不定，却始终影响着历史进程；中本聪虽在2011年神秘消失，却始终影响着全球区块链与RWA行业的发展进程。',
      teaser: '区块链界的"左慈"——他是谁？他消失了吗？他留下的100万枚比特币永远不动，这是一种什么样的哲学？',
      teaserEn: 'The "Zuo Ci" of blockchain — who is he? Did he really disappear? What philosophy lies behind leaving 1 million untouched Bitcoin as a parting gift to the world?',
    },
    projects: ['比特币白皮书', '比特币创世区块', '区块链技术概念提出'],
    color: '#F59E0B',
    icon: 'ri-question-mark',
  },
  {
    id: 'vitalik',
    name: 'Vitalik Buterin',
    nameEn: 'Vitalik Buterin',
    nationality: '加拿大',
    birthYear: '1994',
    category: 'international',
    subCategory: '区块链奠基人',
    title: '以太坊创始人 · "世界计算机"提出者',
    titleEn: 'Founder of Ethereum · Creator of "The World Computer"',
    affiliation: '以太坊基金会',
    affiliationEn: 'Ethereum Foundation',
    education: '多伦多大学辍学（后获荣誉博士）',
    headline: '19岁撰写以太坊白皮书 · 将区块链从"数字货币"升级为"可编程价值网络" · 身价数百亿却住出租屋写代码',
    headlineEn: 'Wrote Ethereum whitepaper at 19 · Upgraded blockchain from "digital cash" to "programmable value network" · Worth billions, still rents an apartment to write code',
    achievements: [
      '17岁从父亲处听说比特币，立刻沉迷',
      '19岁辍学撰写以太坊白皮书，获YC基金支持',
      '2015年推动以太坊主网上线，引入图灵完备智能合约',
      '以太坊成为全球最大的区块链生态',
      '持续推动以太坊技术升级（合并、分片），支撑RWA规模化发展',
    ],
    rwaContribution: '以太坊的智能合约为RWA的复杂规则编程（分红、质押、赎回、跨境流转）提供了核心技术平台，成为RWA落地的最主要底层基础设施。超过80%的全球RWA项目部署在以太坊生态上。',
    story: '从小是数学天才，3位数心算比计算器还快。如今身价数百亿，却依然穿着印有以太坊Logo的T恤，住在新加坡的出租屋里写代码，被称为"最不像亿万富翁的亿万富翁"。',
    historicalParallel: {
      novel: 'shuihu',
      novelEn: 'Water Margin (Outlaws of the Marsh)',
      character: '柴进',
      characterEn: 'Chai Jin',
      intro: '柴进出身名门、仗义疏财，广纳天下英雄好汉，为梁山的发展积累了大量人才和资源，搭建起梁山的"聚义厅"；Vitalik创建以太坊平台，为全球区块链开发者和RWA项目方提供技术平台，搭建起全球最大的区块链"聚义厅"。',
      introEn: 'Chai Jin was the wealthy nobleman who provided a haven for all heroes, building the foundation for the Liangshan fellowship. Vitalik built Ethereum as the ultimate "gathering hall" for global blockchain developers, giving every RWA project a home.',
      detail: '柴进的"仗义疏财"在于为天下英雄提供容身之所；Vitalik的"生态搭建"在于为全球区块链和RWA从业者提供技术平台和发展机会，让他们的才能得以施展。柴进为人低调、不恋权位；Vitalik为人低调、不恋财富，身价数百亿却依然过着简单的生活，只为以太坊生态和区块链技术的发展。',
      teaser: '"区块链界的柴进"——19岁辍学少年如何建立起改变世界金融格局的"聚义厅"，成为RWA的核心基础设施？',
      teaserEn: 'The "Chai Jin" of blockchain — how did a 19-year-old dropout build the "gathering hall" that changed global finance and became the backbone of the entire RWA ecosystem?',
    },
    projects: ['以太坊白皮书', '以太坊主网', '图灵完备智能合约', '以太坊合并（PoS转型）'],
    color: '#6366F1',
    icon: 'ri-ethereum-line',
  },
  {
    id: 'sergey-nazarov',
    name: 'Sergey Nazarov',
    nameEn: 'Sergey Nazarov',
    nationality: '美国（俄裔）',
    birthYear: '1987',
    category: 'international',
    subCategory: 'RWA基础设施',
    title: 'Chainlink联合创始人兼CEO · 去中心化预言机领域开创者',
    titleEn: 'Co-founder & CEO, Chainlink · Pioneer of Decentralized Oracle Networks',
    affiliation: 'Chainlink Labs',
    affiliationEn: 'Chainlink Labs',
    education: '纽约大学哲学与管理学士（2007）',
    headline: '"哲学让我思考什么是信任，Chainlink就是我对信任问题的技术解答" · 支撑全球超7万亿美元链上交易价值',
    headlineEn: '"Philosophy taught me to question trust; Chainlink is my answer" · Secures $7 trillion+ in on-chain value globally',
    achievements: [
      '2016年联合创立Chainlink，首次提出去中心化预言机概念',
      '2019年推动Chainlink主网上线',
      'Chainlink支撑全球超7万亿美元的链上交易价值（截至2026年）',
      '主导制定预言机行业标准，推动跨链数据交互协议研发',
      '通过Chainlink Grants计划扶持RWA技术创新',
    ],
    rwaContribution: '去中心化预言机技术为RWA提供了关键支撑，实现实体资产价格、产权状态、财报数据等现实信息的可信上链，让RWA资产与现实世界精准锚定。没有Chainlink，RWA资产就无法知道自己代表的现实资产的实时价值。',
    story: '哲学系毕业生创业做区块链基础设施，打破"技术从业者必是理工科背景"的刻板印象。2019年主网上线时，团队仅10人，面对行业对"预言机安全性"的广泛质疑，带领团队用3年时间完成30余次安全审计，最终赢得市场认可。',
    historicalParallel: {
      novel: 'shuihu',
      novelEn: 'Water Margin (Outlaws of the Marsh)',
      character: '戴宗',
      characterEn: 'Dai Zong',
      intro: '"神行太保"戴宗身怀"日行八百里"的绝技，成为连接梁山与外界的关键枢纽；Sergey凭借Chainlink预言机，能让区块链实时获取并验证现实世界数据，成为RWA资产可信锚定的核心保障。',
      introEn: 'Dai Zong, "The Divine Courier," could travel 800 li per day — the crucial link between Liangshan and the outside world. Sergey\'s Chainlink serves the same role: the trusted messenger that connects blockchain with real-world data, making RWA possible.',
      detail: '戴宗的神行术靠"甲马"辅助，且始终坚守忠义初心；Sergey的预言机技术也靠无数次安全审计迭代，且始终坚守"可信数据"的初心，只为打破区块链与现实世界的壁垒。没有戴宗，梁山就无法知道外界的军情；没有Chainlink，RWA资产就无法锚定现实世界的价格和状态。',
      teaser: '区块链的"神行太保"——这位哲学系毕业生如何建立起连接区块链与现实世界的"数据高速公路"？',
      teaserEn: '"The Divine Courier" of blockchain — how did a philosophy graduate build the data highway that connects blockchain to the real world, enabling the entire RWA ecosystem?',
    },
    projects: ['Chainlink去中心化预言机网络', '跨链数据交互协议', 'RWA资产数据喂送方案', 'Chainlink Grants扶持计划'],
    color: '#1D4ED8',
    icon: 'ri-link',
  },
  {
    id: 'hester-peirce',
    name: 'Hester Peirce',
    nameEn: 'Hester Peirce',
    nickname: '"加密妈妈" Crypto Mom',
    nationality: '美国',
    birthYear: '1971',
    category: 'international',
    subCategory: 'RWA监管先锋',
    title: '美国SEC委员 · "加密妈妈" · RWA监管安全港规则提出者',
    titleEn: 'SEC Commissioner · "Crypto Mom" · Author of RWA Safe Harbor Rule',
    affiliation: '美国证券交易委员会（SEC）',
    affiliationEn: 'U.S. Securities and Exchange Commission',
    education: '凯尼恩学院历史学本科；乔治城大学法学博士',
    headline: '"我们不应该杀死一只还在成长的蝴蝶" · 在SEC内部为RWA创新发声的唯一委员 · "加密妈妈"',
    headlineEn: '"We shouldn\'t kill a butterfly that\'s still growing" · The only SEC commissioner who consistently fought for RWA innovation · "Crypto Mom"',
    achievements: [
      '推动美国对"资产支持代币"（RWA）采取清晰的监管分类',
      '提出"安全港"规则，为RWA项目提供1-3年监管缓冲期',
      '多次在SEC内部投票中单独投出反对票，支持合规RWA项目',
      '撰写《数字资产监管框架白皮书》',
      '推动SEC与OCC、CFTC的监管协同，避免RWA多头监管困境',
    ],
    rwaContribution: '在SEC以严厉监管著称的环境下，是唯一一个敢于为区块链创新发声的委员。提出的RWA"安全港"规则，为初创企业提供喘息空间，推动SEC出台更包容的RWA监管政策。',
    story: '在SEC关于RWA项目的处罚投票中，她单独投出反对票，并公开表示："我们不应该杀死一只还在成长的蝴蝶——RWA是连接区块链与实体经济的重要创新，过度监管会扼杀行业活力。"这句话成为行业经典名言。',
    historicalParallel: {
      novel: 'shuihu',
      novelEn: 'Water Margin (Outlaws of the Marsh)',
      character: '顾大嫂',
      characterEn: 'Gu Dasao',
      intro: '顾大嫂性情刚烈、为人仗义，敢于对抗不公，在女性角色中独树一帜；Hester Peirce在SEC这一"官方机构"中为RWA行业仗义执言，成为行业发展的"保护伞"。',
      introEn: 'Gu Dasao was fiery and just, daring to stand against injustice as one of the few female heroes. Hester Peirce embodies the same spirit in the SEC — the rare voice of reason fighting for RWA innovation against institutional resistance.',
      detail: '顾大嫂的"侠气"不在于武功高强，而在于敢于对抗不公；Hester的"勇气"在于敢于坚持真理，反对过度监管。她提出的RWA"安全港"规则，如同顾大嫂劫狱时的"义举"，为初创企业提供了喘息空间。顾大嫂始终坚守"替天行道"的初心；Hester也始终坚守"包容创新"的初心，关注中小企业发展。',
      teaser: 'SEC里的"顾大嫂"——她如何在全是"打压者"的监管机构中，成为美国RWA创新最重要的守护者？',
      teaserEn: 'The "Gu Dasao" inside the SEC — how did she become the most important guardian of RWA innovation inside an institution that seemed determined to crush it?',
    },
    projects: ['RWA"安全港"规则提案', 'SEC RWA监管分类标准制定', '跨机构监管协同倡议'],
    color: '#EC4899',
    icon: 'ri-shield-star-line',
  },
];

export const EXPERT_CATEGORIES = [
  { id: 'academic', label: '学术先驱', labelEn: 'Academic Pioneers', icon: 'ri-graduation-cap-line', color: '#7C3AED' },
  { id: 'industry', label: '产业领袖', labelEn: 'Industry Leaders', icon: 'ri-building-4-line', color: '#DC2626' },
  { id: 'international', label: '国际大咖', labelEn: 'International Figures', icon: 'ri-global-line', color: '#0EA5E9' },
];
